module.exports = __webpack_public_path__ + "img/car-clr-3.a33b3926.png";